import { administrationRequests } from "api/administrationApi";
import React from "react";
import { ReferenceInput, SelectInput } from "react-admin";

const DegreeInput = ({ handleChange, readOnly, source = "degreeId", label = "ОКС" }) => {
  return (
    <ReferenceInput
      source={source}
      reference={administrationRequests.getDegreesSelect()}
    >
      <SelectInput
        label={label}
        onChange={handleChange}
        readOnly={readOnly}
      />
    </ReferenceInput>
  );
};

export default DegreeInput;
